module.exports = __webpack_public_path__ + "media/images/icon-svg/wild-e9042e38b3666964050ed4f273406d06.svg";